import { useEffect } from 'react';
import { refreshToken } from '~/components/Dosi/Vault';
import { ErrorMessage, ErrorMessageProps } from '~/components/Error/Message/v2/ErrorMessage';

export type RevokedErrorMessageProps = ErrorMessageProps;
export const RevokedErrorMessage = (props: RevokedErrorMessageProps) => {
  useEffect(() => {
    refreshToken();
  }, []);
  return <ErrorMessage {...props} />;
};
